import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { EventCreationFormWrapper } from 'src/Components/Forms/Event/EventCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateEventDrawer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const locationState = location.state as {
    isReservation?: boolean;
    defaultDate?: number;
    defaultHouseholdId?: string;
  } | null;
  const isReservation = locationState?.isReservation ?? false;
  const defaultDate = locationState?.defaultDate;
  const defaultHouseholdId = locationState?.defaultHouseholdId;

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={
        isReservation
          ? t('createEventForm.createReservationHeader', 'Créer une réservation')
          : t('createEventForm.createEventHeader', 'Créer un événement')
      }
      to={`/asset/${assetId}/planning`}
    >
      {({ onClose }) => (
        <EventCreationFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          isReservation={isReservation}
          defaultDate={defaultDate}
          defaultHouseholdId={defaultHouseholdId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default CreateEventDrawer;
